import React, { useState } from "react";
import { Alert, Box, Button, Paper, Stack, TextField, Typography } from "@mui/material";
import { useApiCallMutation } from "../../Services/ApiCallService";
import { coreAPIEndsPoints } from "../../Config/APIsEndpoints";
import { isLdsAdmin } from "../../Forms/TieredTreeBuilder/treeLogic";
import { bindingErrors, bindRequest, selfBinding } from "./portalAccessLogic";

const readUserInfo = () => {
  try {
    return JSON.parse(localStorage.getItem("userInfo"));
  } catch {
    return null;
  }
};

const PortalAccess = () => {
  const userInfo = readUserInfo();
  const [bindPrincipal, bindState] = useApiCallMutation();
  const [form, setForm] = useState({ userId: "", principal: "" });
  const [errors, setErrors] = useState({});
  const [result, setResult] = useState(null);

  if (!isLdsAdmin(userInfo)) {
    return (
      <Box p={3}>
        <Alert severity="info">Only LDS admins can set portal owner emails.</Alert>
      </Box>
    );
  }

  const update = (field) => (e) => setForm({ ...form, [field]: e.target.value });

  const save = async () => {
    const found = bindingErrors(form);
    setErrors(found);
    setResult(null);
    if (Object.keys(found).length) return;
    try {
      const res = await bindPrincipal({
        endPoint: coreAPIEndsPoints.bindPrincipal,
        method: "POST",
        data: bindRequest(form),
      }).unwrap();
      if (res?.status?.code === 200) {
        setResult({ severity: "success", text: `User ${form.userId.trim()} is now bound to ${form.principal.trim().toLowerCase()}.` });
      } else {
        setResult({ severity: "error", text: typeof res?.data === "string" ? res.data : "The owner email was not saved." });
      }
    } catch (err) {
      setResult({
        severity: "error",
        text: err?.status === 403 ? "Your account does not have the LDS admin role." : "The owner email was not saved.",
      });
    }
  };

  return (
    <Box p={3} maxWidth={560}>
      <Paper sx={{ p: 3 }}>
        <Stack spacing={2}>
          <Typography variant="h6">Portal access</Typography>
          <Typography variant="body2" color="text.secondary">
            A portal user can load LDS only after an admin sets the login email that owns their user ID. Setting it again
            moves the user ID to the new email. Module permissions are not changed.
          </Typography>
          <TextField
            label="User ID"
            value={form.userId}
            onChange={update("userId")}
            error={!!errors.userId}
            helperText={errors.userId}
            size="small"
          />
          <TextField
            label="Owner email"
            value={form.principal}
            onChange={update("principal")}
            error={!!errors.principal}
            helperText={errors.principal}
            size="small"
          />
          <Stack direction="row" spacing={1}>
            <Button variant="contained" onClick={save} disabled={bindState?.isLoading}>
              Save
            </Button>
            <Button variant="outlined" onClick={() => setForm(selfBinding(userInfo))}>
              This is me
            </Button>
          </Stack>
          {result && <Alert severity={result.severity}>{result.text}</Alert>}
        </Stack>
      </Paper>
    </Box>
  );
};

export default PortalAccess;
